
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class ItemDiscountDialog extends Serenity.EntityDialog<ItemDiscountRow, any> {
        protected getFormKey() { return ItemDiscountForm.formKey; }
        protected getIdProperty() { return ItemDiscountRow.idProperty; }
        protected getLocalTextPrefix() { return ItemDiscountRow.localTextPrefix; }
        protected getNameProperty() { return ItemDiscountRow.nameProperty; }
        protected getService() { return ItemDiscountService.baseUrl; }
        protected getDeletePermission() { return ItemDiscountRow.deletePermission; }
        protected getInsertPermission() { return ItemDiscountRow.insertPermission; }
        protected getUpdatePermission() { return ItemDiscountRow.updatePermission; }

        protected form = new ItemDiscountForm(this.idPrefix);

    }
} 